module.exports = __webpack_public_path__ + "public/images/dropdown-arrow.5e9146ddf85a9c6c6c7dedd9587f2ea5.svg";